import { Radio as MuiRadio, RadioProps } from '@mui/material';
import {
  CheckedColorInputIcon,
  UncheckedColorInputIcon,
} from './ColorInputIcon';

export default function Radio(
  props: RadioProps & { colorName: string; hideLabel?: boolean },
) {
  const { colorName, hideLabel, ...otherProps } = props;

  return (
    <MuiRadio
      disableRipple
      color='default'
      sx={
        hideLabel
          ? {
              padding: 0,
            }
          : {}
      }
      checkedIcon={
        <CheckedColorInputIcon colorName={colorName} borderRadius='50%' />
      }
      icon={
        <UncheckedColorInputIcon colorName={colorName} borderRadius='50%' />
      }
      {...otherProps}
    />
  );
}
